import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';
import { ScrollToService } from '@df/dom/scroll/scroll-to.service';
import { ZippyModule } from '@df/legacy/ui/zippy/zippy.module';
import { ZippyService } from '@df/legacy/ui/zippy/zippy.service';
import { BarclaycardFlexMicroformComponentDef } from '@df/module-barclaycard/flex-microform/barclaycard-flex-microform.component.def';
import { CustomerModel } from '@df/session/api/customer.model';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { CheckoutFormComponent } from '../../../checkout/form/checkout-form.component';
import { CheckoutStepComponent } from '../../../checkout/step/checkout-step.component';
import { ResultComponent } from '../../../ui/api/result.component';
import { PaymentIconComponent } from '../../../ui/display/payment-icon/payment-icon.component';
import { CheckboxComponent } from '../../../ui/form/checkbox';
import { InputWrapBodyDirective } from '../../../ui/form/input-wrap-body.directive';
import { InputWrapComponent } from '../../../ui/form/input-wrap.component';

@Component({
    selector: 'barclaycard-flex-microform',
    templateUrl: 'barclaycard-flex-microform.html',
    styleUrls: ['barclaycard-flex-microform.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    standalone: true,
    imports: [
        ResultComponent,
        CheckboxComponent,
        FormsModule,
        InputWrapComponent,
        NgClass,
        TranslationModule,
        PaymentIconComponent,
        InputWrapBodyDirective,
        ZippyModule
    ]
})
export class BarclaycardFlexMicroformComponent extends BarclaycardFlexMicroformComponentDef {
    months = Array.from({ length: 12 }, (_, i) => (i + 1).toString().padStart(2, '0'));
    years = Array.from({ length: 15 }, (_, i) => (new Date().getFullYear() + i).toString());

    constructor(
        checkoutFormComponent: CheckoutFormComponent,
        changeDetectorRef: ChangeDetectorRef,
        protected override scrollToService: ScrollToService,
        checkoutStepComponent: CheckoutStepComponent,
        private zippyService: ZippyService,
        private customer: CustomerModel
    ) {
        super(checkoutFormComponent, changeDetectorRef, scrollToService, checkoutStepComponent);
        this.subscriptions.add(customer.obs.data.subscribe(() => this.detectChanges()));
    }

    /**
     * Returns if we want to preload scripts and initiate form on component init
     * @returns {boolean}
     */
    protected override preload(): boolean {
        return true;
    }

    closeZippy(name: string): void {
        this.zippyService.close(name);
    }

    get paymentIconMethod(): string {
        return {
            VI: 'visa',
            MC: 'mc',
            AE: 'amex'
        }[this.creditCardType];
    }
    selectYear(year: string): void {
        this.creditCardExpYear = year;
        this.detectChanges();
    }

    selectMonth(month: string): void {
        this.creditCardExpMonth = month;
        this.detectChanges();
    }

    get canSaveCard(): boolean {
        return !!this.method?.isVaultEnabled && this.customer.isLoggedIn;
    }
}
